<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="480px">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span>Change NAP</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Nap Code*"
                      v-model="form.napCode"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Port*"
                      v-model="form.port"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingBtn" @click.native="cancel">
                Close
              </v-btn>
              <v-btn
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onSubmit()"
                class="px-10"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <Snackbar></Snackbar>
    </v-col>
  </v-row>
</template>

<script>
// import moment from "moment";
import Snackbar from "../Snackbar.vue";
import ShareableMethods from "@/mixins/ShareableMethods";

export default {
  mixins: [ShareableMethods],
  name: "ChangeNapDialog",
  components: {
    Snackbar,
  },
  data() {
    return {
      dispatchStatus: [],
      assignToList: [],

      dialog: false,
      resolve: null,
      reject: null,

      selectedData: null,

      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },

      form: {
        napCode: "",
        port: "",
        referenceNumber: "",
      },
    };
  },

  methods: {
    open(data) {
      this.dialog = true;

      this.selectedData = data;
      //
      setTimeout(() => {
        const currentData = data;
        const form = this.form;
        Object.keys(form)
          .filter((key) => key in currentData)
          .forEach((key) => {
            form[key] = currentData[key];
          });
      }, 500);
      // this.getDispatchConfig();
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.loadingBtn = true;

      await this.$api
        .put("/acquisition/change-nap", this.form)
        .then((response) => {
          const res = response.data;

          if (!res.status) {
            this.loadingBtn = false;
            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);
            return;
          }

          this.loadingBtn = false;
          this.$refs.form.reset();
          this.$store.dispatch(
            "addSnackbarMessage",
            res.message
          );
          this.$store.dispatch("addSnackbar", true);
          this.agree();
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    },

    async getDispatchConfig() {
      await this.$api
        .get("/dispatch/config")
        .then((response) => {
          const res = response.data.data;
          this.dispatchStatus = res.statuses;
          this.assignToList = res.assignedTo;
        })
        .catch((e) => {
          // this.table.loading = false;
          console.log(e);
        });
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },

    cancel() {
      this.resolve(false);
      this.$refs.form.reset();
      this.dialog = false;
    },
  },

  created() {},
};
</script>

<style scoped>
.images > img {
  cursor: pointer;
}
</style>
